export default "__VITE_ASSET__BqF2ngGR__"